import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { useLocalization } from '@/hooks/localization'
import { Button } from '@/components/button'
import context from '@/context'
import { downloadFile } from '@/utils/downloader'
import { switchInstitution } from '@/utils/switchInstitution'

const DownloadExportButton = ({ data, openDialog }) => {
  const { localize } = useLocalization()
  const onDownloadError = useCallback(() => {
    openDialog({
      dialogType: dialogTypes.alert,
      title: 'Reporting.GenerateExcel',
      content: 'Reporting.ExportDownloadError'
    })
  }, [openDialog])

  const onDownloadCallback = useCallback(() => {
    const input = {
      reportSubmissionGroupId: data.reportGroupSubmissionId,
      fileAttachmentId: data.fileId
    }

    let api
    if (data.reportType === 'OutputReport') api = context.api.outputReportGroupService.downloadExport
    if (data.reportType === 'ReportSubmission') api = context.api.reportSubmissionGroupService.downloadExport

    if (api) downloadFile(input, api, null, null, onDownloadError)
  }, [data, onDownloadError])

  const onDownload = useCallback(() => {
    switchInstitution(null, data.institutionId, null, onDownloadCallback)
  }, [onDownloadCallback, data])

  if (data && data.fileId && typeof data.reportGroupSubmissionId === 'number') {
    return <Button size='sm' color='success' icon='download' onClick={onDownload}><span>{localize('Common.Download')}</span></Button>
  }

  return null
}

const mapDispatchToProps = {
  openDialog: actionCreators.openDialog
}

export default connect(null, mapDispatchToProps)(DownloadExportButton)



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/downloadExportButton.js